import type { ManifestRouteDefinition } from '@/core/manifest/types'

export const moduleFeatureConfigRouteRoot: ManifestRouteDefinition = {
  key: 'module_feature_configuration',
  path: '/module-feature-configuration',
  lazyComponent: () =>
    import('@/features/moduleFeatureConfig/pages/ModuleFeatureConfigPage/ModuleFeatureConfigPage').then(
      (m) => ({
        default: m.default,
      })
    ),
  indexRedirect: undefined,
  apiCalls: [],
}
